import { FC } from 'react';

import EDITSVG from '../../../../assets/icons/edit.svg';
import { Typography } from '../../../../designComponents';
import { BillShipStyled } from './style';

interface BillShipDataPropsTypes {
  clientName: string;
  emailAddress: string;
  billAddress: string;
  city: string;
  country: string;
  postalCode: string;
  name: string;
  shipAddress: string;
  phone: string;
}

const BillShip: FC<BillShipDataPropsTypes> = ({
  billAddress,
  city,
  clientName,
  country,
  emailAddress,
  name,
  phone,
  postalCode,
  shipAddress,
}) => {
  return (
    <BillShipStyled>
      <div className="bill-head">
        <div className="bill-tab">
          <Typography fontColor="white">BILL TO</Typography>
          <img src={EDITSVG} alt="edit icon" />
        </div>
        <div className="bill-data">
          <Typography>Client Name: {clientName}</Typography>
          <Typography>Email Address: {emailAddress}</Typography>
          <Typography>Address: {billAddress}</Typography>
          <Typography>City: {city}</Typography>
          <Typography>Country: {country}</Typography>
          <Typography>Postal Code: {postalCode}</Typography>
        </div>
      </div>
      <div className="ship-head">
        <div className="ship-tab">
          <Typography fontColor="white">SHIP TO</Typography>
          <img src={EDITSVG} alt="edit icon" />
        </div>
        <div className="ship-data">
          <Typography>Name: {name}</Typography>
          <Typography>Address: {shipAddress}</Typography>
          <Typography>Phone: {phone}</Typography>
        </div>
      </div>
    </BillShipStyled>
  );
};

export default BillShip;
